var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogoExtension(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 64 64",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M54.6 40.7L28.2 56 M35.8 41.8L35.8 29.8 M35.8 29.8L54.6 18.9 M35.8 29.8L16.9 18.9 M16.9 30.9L16.9 18.9 M16.9 18.9L35.8 8 M54.6 40.7L54.6 18.9 M54.6 18.9L35.8 8 M28.2 56L9.4 45.1 M28.2 56L28.2 46.2 M28.2 46.2L35.8 41.8 M28.2 46.2L9.4 35.3 M9.4 45.1L9.4 35.3 M9.4 35.3L16.9 30.9 M35.8 41.8L16.9 30.9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoExtension);
export default __webpack_public_path__ + "static/media/logo_extension.148e2b4ae63f02e14da4bcde82390278.svg";
export { ForwardRef as ReactComponent };